module.exports = __webpack_public_path__ + "img/Andy Whitt.535e7f78.jpg";